<template>
	<div :class="['image-view', hovering ? 'hovering' : null]" @drop="drop" @dragover="dragover" @dragenter="dragenter" @dragleave="dragleave">
		<div class="hide">
			<input class="file" ref="file" type="file" />
		</div>
		<div class="preview">
			<div class="image" :style="_image_style"></div>
			<div class="slot">
				<slot />
			</div>
		</div>
		<div class="upload">
			<div class="icon">
				<lottie-view :options="{ animationData: require('@/assets/icons/animated/upload.json') }" />
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			value: {
				type: String,
				default: null
			},
			src: {
				type: String,
				default: null
			},
			alt: {
				type: String,
				default: null
			},
			shape: {
				type: String,
				default: 'rect',
				validator(val) {
					return ['rect', 'square', 'circle'].includes(val);
				}
			},
			mode: {
				type: String,
				default: 'fill',
				validator(val) {
					return ['fit', 'fill', 'stretch'].includes(val);
				}
			},
			changed: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
				hovering: false,
				altValue: null
			};
		},
		computed: {
			_image_data() {
				return this.src ? this.value : (this.alt ? this.altValue : null);
			},
			_image_style() {
				return {
					backgroundImage: this._image_data ? `url(${this._image_data})` : 'none',
					backgroundSize: this.mode == 'fit' ? 'contain' : (this.mode == 'fill' ? 'cover' : '100% 100%')
				};
			}
		},
		watch: {
			src: {
				handler(n) {
					const self = this;

					if (n) {
						this.urlToDataURL(n, (data) => {
							self.$emit('input', data);
						});
					} else {
						this.$emit('input', null);
					}
				},
				immediate: true
			},
			alt: {
				handler(n) {
					const self = this;

					if (n) {
						this.urlToDataURL(n, (data) => {
							self.altValue = data;
						});
					} else {
						this.altData = null;
					}
				},
				immediate: true
			}
		},
		methods: {
			urlToDataURL(url, callback) {
				const canvas 	= document.createElement('canvas');
				const ctx 		= canvas.getContext('2d');

				var img = new Image();
				img.crossOrigin = 'anonymous';
				img.src = url;

				img.onload = () => {
					canvas.width 	= img.width;
					canvas.height 	= img.height;

					ctx.drawImage(img, 0, 0);
				
					callback(canvas.toDataURL('image/jpeg'));

					canvas.remove();
				}
			},
			drop(event) {
				event.preventDefault();

				const self 		= this;
				const reader 	= new FileReader();
				const files 	= event.dataTransfer.files;

				this.hovering = false;

				reader.onload = function(event){
					self.$emit('input', event.target.result);
					self.$emit('update:changed', true);
					
				};
				
				reader.readAsDataURL(files[0]);
			},
			dragover(event) {
				event.preventDefault();
			},
			dragenter() {
				this.hovering = true;
			},
			dragleave() {
				this.hovering = false;
			}
		}
	}
</script>

<style lang="scss" scoped>
	.image-view {
		position: relative;
		display: inline-block;

		& > * {
			pointer-events: none;
		}

		& > .preview {
			opacity: 1;
			position: absolute;
			left: 0;
			top: 0;
			width: 100%;
			height: 100%;

			& > .image {
				position: absolute;
				left: 0;
				top: 0;
				width: 100%;
				height: 100%;
				background-position: center center;
			}

			& > .slot {
				position: absolute;
				left: 0;
				top: 0;
				width: 100%;
				height: 100%;
			}
		}

		& > .hide {
			position: relative;
			overflow: hidden;
			height: 0;

			& > .file {
				position: absolute;
				top: -100px;
			}
		}

		& > .upload {
			opacity: 0;
			transition: opacity 250ms;

			position: absolute;
			left: 0;
			top: 0;
			width: 100%;
			height: 100%;
			background-color: rgba(0, 0, 0, 0.8);

			& > .icon {
				transition: transform 250ms;

				position: absolute;
				width: 96px;
				left: 50%;
				top: 50%;
				transform: translate(-50%, -50%) scale(0.5);
			}
		}

		&.hovering {
			& > .preview {
				opacity: 1;
			}

			& > .upload {
				opacity: 1;

				& > .icon {
					transform: translate(-50%, -50%) scale(1);
				}
			}
		}
	}
</style>